import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Search from '@material-ui/icons/Search';
import React from 'react';
import Edit from '@material-ui/icons/Edit';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import DeleteIcon from '@material-ui/icons/Delete';
import { Link } from 'react-router-dom';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import Utils from '../share/Utils';
import AlertDialogSlide from '../share/AlertDialogSlide';
import LongMenu from '../share/LongMenu';
import { Fade, Avatar } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import ToolbarNovo from './ToolbarNovo';
import VariantSnackbar from '../share/VariantSnackbar';
import DialogErrosValidacao from '../share/DialogErrosValidacao';
import FormDialogDentista from './FormDialogDentista';
import AssistenciaOdontoService from '../../services/AssistenciaOdontoService';
import { inject, observer } from 'mobx-react';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    display: 'block',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 220,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    width: 600,
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
  },
  searchIcon: {
    marginLeft: theme.spacing.unit,
  },
  input: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    // cursor: 'pointer',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    marginLeft: '20px'
  },
});
@inject('usuarioStore')
@observer
class DentistaCadastro extends React.Component {
  assistenciaOdontoService = new AssistenciaOdontoService();
  utils = new Utils();
  state = {
    dentistas: [],
    filtro: '',
    fetching: false,
    buscarDisabled: true,
    anchorEl: null,
    dentistaSelecionado: {},    
    modoInclusao: true,
    isEditavel: true,
    tituloFormDialog: '',
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    snackSucesso: true,
    openDialog: false,
    openDialogValidacao: false,
    openDialogExclusao: false,
    dialogTitle: '',
    dialogContent: '',
    dialogMessageExclusao: '',
  }

  consultarDentistas = async () => {
    if (this.state.filtro !== '') {
      this.setState({fetching: true});
      var criterio = this.state.filtro;
      var bolCPF_CNPJ = /^([0-9]{1,14})$/.test(criterio.replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', ''));
      var bolNome = /^([ \u00c0-\u01ffa-zA-Z'-])+$/.test(criterio.toUpperCase());
      var CPF_CNPJ = 'vazio';
      var nome = 'vazio';
      if (bolCPF_CNPJ) {
        CPF_CNPJ = criterio;
      }
      if (bolNome) {
        nome = criterio.toUpperCase();
      }
      if (bolCPF_CNPJ || bolNome) {
        const dentistas = await this.assistenciaOdontoService.consultarDentistas(CPF_CNPJ.replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', ''), nome.replace('/', '#'));
        this.setState({dentistas: dentistas});
      } else {
        nome = criterio.toUpperCase();
        const dentistas = await this.assistenciaOdontoService.consultarDentistas(CPF_CNPJ.replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', ''), nome.replace('/', '#'));
        this.setState({dentistas: dentistas});
      }
      this.setState({fetching: false, buscarDisabled: false});
    }
  }

  handleClickBuscar = async (event) => {
    event.preventDefault();
    await this.consultarDentistas();
  }

  handleChangeInput = name => event => {
    this.setState({[name]: event.target.value.toUpperCase(), buscarDisabled: event.target.value === ''});
  }

  handleClickTrash = name => {
    this.setState({[name]: '', buscarDisabled: true});
  }

  handleClickMenu = (event, tableMeta) => {
    const dentistaSelecionado = {
      codDentista: this.state.dentistas[tableMeta.rowIndex][0],
      nomDentista: this.state.dentistas[tableMeta.rowIndex][1],
      numCro: this.state.dentistas[tableMeta.rowIndex][2],
      numCpfCgc: this.utils.cpfOuCnpj(this.state.dentistas[tableMeta.rowIndex][3]),
      numFone: this.utils.formataTelefoneTextField(this.state.dentistas[tableMeta.rowIndex][4].toString().length === 7 ? '3' + this.state.dentistas[tableMeta.rowIndex][4].toString() : this.state.dentistas[tableMeta.rowIndex][4]),      
    };
    this.setState({ anchorEl: event.currentTarget, dentistaSelecionado: dentistaSelecionado });
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }

  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    if (index === 0) {
      this.setState({openDialog: true, tituloFormDialog: 'Alteração de Dentista/Consultório - ' + this.state.dentistaSelecionado.nomDentista, modoInclusao: false, isEditavel: true});
    }
    if (index === 1) {
      this.setState({openDialogExclusao: true, tituloFormDialog: 'Excluir Dentista/Consultório - ' + this.state.dentistaSelecionado.nomDentista, dialogMessageExclusao: 'Deseja excluir este dentista/consultório?'});
    }
  }

  handleDialogClose = async () => {
    this.setState({openDialog: false});
  }
  handleCloseDialogExcluir = () => {
    this.setState({ openDialogExclusao: false });
  };

  onOperacaoFinalizadaDialog = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        fetching: false,
        snackSucesso: false,
        openDialog: false});        
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({
          snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          fetching: false,
          snackSucesso: true});
      } else {
        this.setState({
          openDialogValidacao: true,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          registrosSemErros: result.data.registrosSemErros,
          fetching: false,
          openDialog: false});
      }
    }
    await this.consultarDentistas();
  }

  incluirDentista = async (dentista) => {
    this.setState({fetching: true, dentistaSelecionado: {}, filtro: dentista.nomDentista});
    let result = await this.assistenciaOdontoService.incluirDentista(dentista);
    await this.onOperacaoFinalizadaDialog(result);
    this.setState({openDialog: false});    
  }

  alterarDentista = async (dentista) => {
    this.setState({fetching: true, dentistaSelecionado: {}});
    let result = await this.assistenciaOdontoService.alterarDentista(dentista);
    await this.onOperacaoFinalizadaDialog(result);
    this.setState({openDialog: false});
  }

  excluirDentista = async () => {
    this.setState({fetching: true});
    await this.assistenciaOdontoService.excluirDentista(this.state.dentistaSelecionado.codDentista);
    this.setState({snackOpen: true, snackMessage: 'Dentista/consultório excluído com sucesso.', fetching: false, snackSucesso: true});
    await this.consultarDentistas();
  }

  handleDialogConfirmExcluir = async () => {
    this.setState({ openDialogExclusao: false, fetching: true });
    await this.excluirDentista();
  }

  handleClickIncluir = () => {
    this.setState({openDialog: true, tituloFormDialog: 'Inclusão de Dentista/Consultório', dentistaSelecionado: {}, modoInclusao: true, isEditavel: true});
  }

  handleClickToolBar = () => {
    this.setState({ fetching: true });
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  handleCloseDialogValidacao = () => {
    this.setState({ openDialogValidacao: false });
  }

  render () {
    const options = {
      customToolbar: () => (
        <ToolbarNovo
          handleClickIncluir={this.handleClickIncluir}
        />
      ),
      print: false,
      download: false,
      selectableRows: false,
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
      }
    };
    const columns = [
      {
        name: 'Código',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'CRO',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return (
              <Typography>{value === 0 ? '-' : value}</Typography>
            );
          },
        }
      },
      {
        name: 'CPF/CNPJ',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return (
              <Typography>{this.utils.cpfOuCnpj(value)}</Typography>
            );
          },
        }
      },
      {
        name: 'Telefone',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return (
              <Typography>{value === 0 ? '-' : this.utils.formataTelefoneTextField(value.toString().length === 7 ? '3' + value.toString() : value)}</Typography>
            );
          },
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <Edit />,
                primaryText: 'Editar Dentista...',
                visible: true,
                disabled: false
              },
              {
                index: 1,
                icon: <DeleteIcon />,
                primaryText: 'Excluir Dentista...',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
    ];

    const { classes } = this.props;
    const { fetching, dentistas } = this.state;
    return (
      <React.Fragment>
        <Link to='/financeiro' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Dentistas/Consultórios</Typography>
              {dentistas && <Avatar className={classes.avatar}>{dentistas.length}</Avatar>}
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <form className={classes.container} noValidate>
            <FormControl className={classes.formControl}>
              <TextField
                placeholder='Busque pelo nome, CPF ou CNPJ...'
                className={classes.textField}
                onChange={this.handleChangeInput('filtro')}
                value={this.state.filtro}
                autoFocus
                InputProps={{
                  endAdornment: (
                    <InputAdornment variant='filled' position='end'>
                      <IconButton
                        disabled={this.state.buscarDisabled}
                        title='Limpar'
                        onClick={() => this.handleClickTrash('filtro')}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <Button
              variant='extendedFab'
              title='Consultar'
              disabled={this.state.buscarDisabled}
              type='submit'
              onTouchStart={this.handleClickBuscar}
              onClick={this.handleClickBuscar}
              className={classes.button}>
              <Search className={classes.searchIcon} />
              Buscar
            </Button>
          </form>
        </Paper>
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={dentistas}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>
        }
        {this.state.openDialog &&
          <FormDialogDentista
            open={this.state.openDialog}
            modoInclusao={this.state.modoInclusao}
            handleClose={this.handleDialogClose}
            titulo={this.state.tituloFormDialog}
            codDentista={this.state.dentistaSelecionado.codDentista}
            dentista={this.state.dentistaSelecionado}
            handleSave={this.state.modoInclusao ? this.incluirDentista : this.alterarDentista}
            isEditavel={this.state.isEditavel} />}
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.snackSucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          duration={3000}
          handleClose={this.handleCloseSnackbar} />
        <AlertDialogSlide
          open={this.state.openDialogExclusao}
          handleClose={this.handleCloseDialogExcluir}
          handleClick={this.handleDialogConfirmExcluir}
          title={this.state.tituloFormDialog}
          message={this.state.dialogMessageExclusao} />
        {this.state.openDialogValidacao &&
          <DialogErrosValidacao
            open={this.state.openDialogValidacao}
            handleClose={this.handleCloseDialogValidacao}
            erros={this.state.dialogContent}
            titulo={this.state.dialogTitle}
          />}

      </React.Fragment>
    );
  }
}

export default withStyles(styles)(DentistaCadastro);
